import axios from "axios";
import { toastError } from "components/ToastError";
import i18n from "i18n";
import { resetLocalStorage } from "utils/HomeHelpers";

let API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Access-Control-Allow-Origin": process.env.REACT_APP_ACL_ORIGIN!,
    "Content-type": "application/json",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
  },
});
// Set the AUTH token for any request
API.interceptors.request.use(function (config) {
  const token = localStorage.getItem("abjadToken");
  if (config?.headers) config.headers.Authorization = token ? token : "";
  return config;
});

API.interceptors.response.use(
  (response) => {
    const { data } = response;
    if (data._statusCode === 401) {
      resetLocalStorage();
      localStorage.setItem("expired", "true");
      toastError({
        label: i18n.t("error"),
        message: i18n.t("Session Expired"),
        toastId: "session-expired",
        rtl: i18n.dir() === "rtl",
        autoClose: 8000,
      });
      setTimeout(
        () => (window.location = "/login" as (string | Location) & Location),
        2000
      );
    } else return response;
  },
  (error) => {
    const expectedError =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;
    if (!expectedError) {
      console.log(error);
      toastError({
        label: i18n.t("error"),
        message: i18n.t("Technical Erorr"),
        toastId: "technical-issue",
        rtl: i18n.dir() === "rtl",
      });
    }
    return Promise.reject(error);
  }
);

export const downloadReport = async (
  classId: number,
  type: string,
  saId = null
) => {
  const token = localStorage.getItem("abjadToken")!;
  let url = `${process.env.REACT_APP_API_URL}ams/class/${classId}/assessment/download?reportType=${type}`;
  if (saId) url += `&saId=${saId}`;
  return await axios
    .get(url, {
      responseType: "blob",
      headers: { Authorization: token },
    })
    .catch(function (error) {
      return error;
    });
};

export const sendQRcodesByEmail = async (data: FormData) => {
  return await API.post("/cms/email/student-login-details-old", data);
};

// export const getTutorialVideoMetaData = async () => {
//   return await axios.get(process.env.REACT_APP_TUTORIAL_JSON_URL);
// };
